import { TelegramSenderLayout } from "../TelegramSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { TelegramSenderEntities } from "../TelegramSenderEntities";
import { TelegramSenderRouterProps } from "../TelegramSenderRouterProps";

export interface IProviderPageProps extends NSARouterMakerResult, TelegramSenderRouterProps { }

function ProviderViewPage(props: IProviderPageProps)
{
	return (
		<TelegramSenderLayout {...props}
			action={{
				description: "This section displays detailed information about a selected Telegram provider."
			}}
			pages={{
				entity: TelegramSenderEntities.provider(props),
				view: {}
			}}
		>
			<></>
		</TelegramSenderLayout>
	);
}

export default ProviderViewPage;